'use client';

import { ReactNode } from 'react';
import { useTranslations } from 'next-intl';

type TranslatedTextProps = {
  text: string;
  valuesAsString?: boolean;
  values?: Record<string, string | number>;
  richValues?: Record<string, (chunks: ReactNode) => ReactNode>;
};

export default function TranslatedText({
  text,
  values,
  richValues,
  valuesAsString,
}: TranslatedTextProps): ReactNode | string {
  const t = useTranslations();

  if (!text) return '--';

  if (richValues) {
    return <>{t.rich(text, richValues)}</>;
  }

  if (values) {
    if (valuesAsString) {
      return t(text, values);
    }
    return <>{t(text, values)}</>;
  }

  return t(text);
}
